import React from 'react';
import { MdFolderOpen } from 'react-icons/md';
import './NoData.css';

const NoData = ({ 
  message = 'No Data Available',
  icon = <MdFolderOpen />,
  subText = 'Try adjusting your search or filters'
}) => {
  return (
    <div className="no-data-container">
      <div className="no-data-icon">
        {icon}
      </div>
      <h3 className="no-data-title">{message}</h3>
      <p className="no-data-text">{subText}</p>
    </div>
  );
};

export default NoData;
